import noUiSlider from 'nouislider';

const formatForSlider = {
    from: function (formattedValue) {
        return Number(formattedValue);
    },
    to: function(numericValue) {
        return Math.round(numericValue);
    }
};

const findParentWithValueElement = (element) => {
    const cardParent = element.closest('.card.style-4');
    const sliderParent = element.closest('.dz-slider');
    return cardParent || sliderParent;
};

export const initializeDistanceSlider = (initialDistance = 40) => {
    const tooltipSlider = document.getElementById('slider-tooltips3');
    if (!tooltipSlider) return;

    if (tooltipSlider.noUiSlider) {
        tooltipSlider.noUiSlider.destroy();
    }

    noUiSlider.create(tooltipSlider, {
        start: initialDistance,
        connect: [true, false],
        format: formatForSlider,
        range: {
            'min': 2,
            'max': 100
        }
    });
    
    tooltipSlider.noUiSlider.on('update', function (values) {
        const parent = findParentWithValueElement(tooltipSlider);
        if (parent) {
            const valueElement = parent.querySelector('.slider-margin-value-min');
            if (valueElement) {
                valueElement.textContent = values[0] + "km";
            }
        }
    });

    return tooltipSlider;
};

export const initializeAgeRangeSlider = (ageSearch = [18, 30]) => {
    console.log("iniage",ageSearch);
    const ageSlider = document.getElementById('slider-tooltips4');
    if (!ageSlider) return;

    if (ageSlider.noUiSlider) {
        // Si le slider existe déjà, mettre à jour ses valeurs
        ageSlider.noUiSlider.set(ageSearch);
        return ageSlider;
    }

    noUiSlider.create(ageSlider, {
        start: ageSearch,
        connect: true,
        format: formatForSlider,
        range: {
            'min': 18,
            'max': 100
        }
    });
    
    ageSlider.noUiSlider.on('update', function (values) {
        const parent = findParentWithValueElement(ageSlider);
        if (parent) {
            const minElement = parent.querySelector('.slider-margin-value-min');
            const maxElement = parent.querySelector('.slider-margin-value-max');
            
            if (minElement && maxElement) {
                minElement.textContent = values[0];
                maxElement.textContent = " - " + values[1];
            }
        }
    });

    return ageSlider;
};

export const destroySlider = (slider) => {
    if (slider && slider.noUiSlider) {
        slider.noUiSlider.destroy();
    }
};
